<template>
	<div class="flex-box">
		<div class="search-box">
			<div v-if="$hasPermission('A10403')">
				<label style="width: auto;" class="searchItemName">渠道：</label>
				<el-select v-model="SelectChannelId" clearable placeholder="筛选渠道">
					<el-option v-for="item in options" :key="item.id" :label="item.channelName" :value="item.id">
					</el-option>
				</el-select>
			</div>

			<div>
				<label class="searchItemName">业务类型：</label>
				<el-select v-model="queryParams.businessType" placeholder="全部" clearable style="width: 160px;">
					<el-option label="全部" :value="0"></el-option>
					<el-option label="驾驶人体检表" :value="6"></el-option>
					<el-option label="健康证申请表" :value="7"></el-option>
					<el-option label="体检从业名单" :value="8"></el-option>
				</el-select>
			</div>

			<div>
				<label class="searchItemName">姓名：</label>
				<el-input class="input-box" placeholder="姓名" v-model="queryParams.idName" clearable>
				</el-input>
			</div>

			<div>
				<label class="searchItemName" style="width: 120px;">身份证后6位：</label>
				<el-input class="input-box" placeholder="身份证后6位" v-model="queryParams.idNumber" clearable maxlength="6" style="width: 150px;">
				</el-input>
			</div>

			<el-button style="margin-left: 10px;" type="primary" v-on:click="GetData()" icon="el-icon-search">查询</el-button>
		</div>

		<el-alert
			title="打印记录仅支持查询与详情查看，不支持补打（产品确认）"
			type="info"
			:closable="false"
			show-icon
			style="margin-top: 10px;">
		</el-alert>

		<div>
			<el-table :data="tableData" border style="width: 100%;margin: 15px 0px;">
				<el-table-column prop="businessNo" label="业务号" width="120" align="center">
				</el-table-column>
				<el-table-column prop="businessType" label="业务类型" width="140" align="center">
					<template slot-scope="scope">
						<el-tag type="info" disable-transitions>{{getBusinessTypeText(scope.row.businessType)}}</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="idName" label="姓名" width="100" align="center">
				</el-table-column>
				<el-table-column prop="idNumber" label="身份证号" width="180" align="center">
					<template slot-scope="scope">
						<span v-if="scope.row.idNumber && scope.row.idNumber.length >= 15">
							{{scope.row.idNumber.substring(0, 4)+"****"+scope.row.idNumber.substring(14)}}
						</span>
						<span v-else>{{scope.row.idNumber}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="dossierNo" label="档案号" width="140" align="center">
				</el-table-column>
				<el-table-column prop="phoneNumber" label="手机号" width="130" align="center">
				</el-table-column>
				<el-table-column prop="payStatus" label="支付状态" width="100" align="center">
					<template slot-scope="scope">
						<el-tag :type="scope.row.payStatus === 1 ? 'success' : 'info'" disable-transitions>
							{{scope.row.payStatus === 1 ? '已支付' : '未支付'}}
						</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="printStatus" label="打印状态" width="100" align="center">
					<template slot-scope="scope">
						<el-tag :type="getPrintStatusTag(scope.row.printStatus)" disable-transitions>
							{{getPrintStatusText(scope.row.printStatus)}}
						</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="printCount" label="打印次数" width="100" align="center">
				</el-table-column>
				<el-table-column prop="createTime" label="创建时间" width="180" align="center">
				</el-table-column>
				<el-table-column label="操作" align="center" min-width="100" fixed="right">
					<template slot-scope="scope">
						<el-button type="primary" size="mini" plain v-on:click="showDetail(scope.row)">详情</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div>
			<el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:current-page.sync="queryParams.pageIndex" :page-sizes="[10, 20, 30, 40, 50]"
				:page-size="queryParams.pageSize" layout="sizes, prev, pager, next" :total="total">
			</el-pagination>
		</div>

		<el-dialog title="打印记录详情" :visible.sync="detailVisible" width="560px">
			<el-descriptions v-if="detail" :column="1" border size="small">
				<el-descriptions-item label="业务号">{{detail.businessNo}}</el-descriptions-item>
				<el-descriptions-item label="业务类型">{{getBusinessTypeText(detail.businessType)}}</el-descriptions-item>
				<el-descriptions-item label="姓名">{{detail.idName}}</el-descriptions-item>
				<el-descriptions-item label="身份证号">{{detail.idNumber}}</el-descriptions-item>
				<el-descriptions-item label="档案号">{{detail.dossierNo}}</el-descriptions-item>
				<el-descriptions-item label="手机号">{{detail.phoneNumber}}</el-descriptions-item>
				<el-descriptions-item label="订单ID">{{detail.orderId}}</el-descriptions-item>
				<el-descriptions-item label="支付状态">{{detail.payStatus === 1 ? '已支付' : '未支付'}}</el-descriptions-item>
				<el-descriptions-item label="打印状态">{{getPrintStatusText(detail.printStatus)}}</el-descriptions-item>
				<el-descriptions-item label="打印次数">{{detail.printCount}}</el-descriptions-item>
				<el-descriptions-item label="最近打印">{{detail.lastPrintTime || '-'}}</el-descriptions-item>
				<el-descriptions-item label="模板版本">{{detail.templateVersion || '-'}}</el-descriptions-item>
				<el-descriptions-item label="文件路径">{{detail.filePath || '-'}}</el-descriptions-item>
				<el-descriptions-item label="创建时间">{{detail.createTime}}</el-descriptions-item>
				<el-descriptions-item label="更新时间">{{detail.updateTime}}</el-descriptions-item>
			</el-descriptions>
			<span slot="footer" class="dialog-footer">
				<el-button @click="detailVisible = false">关 闭</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import {
		post
	} from '../../../../public/request/request.js';
	export default {
		data() {
			return {
				total: 0,
				queryParams: {
					pageIndex: 1,
					pageSize: 10,
					channelId: 0,
					businessType: 0,
					idName: '',
					idNumber: '',
					payStatus: -1,
					printStatus: -1
				},
				options: [],
				tableData: [],
				detailVisible: false,
				detail: null
			}
		},
		methods: {
			GetData() {
				const loading = this.$loading({
					lock: true,
					text: 'Loading',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.4)'
				});
				const params = Object.assign({}, this.queryParams);
				if (params.businessType === '' || params.businessType == null) {
					params.businessType = 0;
				}
				post('418', params)
					.then(response => {
						if (response.data.result == 0) {
							this.tableData = response.data.data.list || [];
							this.total = (response.data.data.pageCount || 0) * this.queryParams.pageSize;
							loading.close();
						} else {
							this.$message.error('查询数据失败:' + response.data.message);
							loading.close();
						}
					})
					.catch(error => {
						this.$message.error((error && error.userMessage) || '查询数据失败');
						loading.close();
					});
			},
			GetChannelData() {
				const allowChannel = sessionStorage.getItem('allowChannel');
				if (allowChannel === 'false') {
					return;
				}
				post('208', {
						channelName: ''
					})
					.then(response => {
						if (response.data.result == 0) {
							this.options = response.data.data;
						} else {
							this.$message.error('获取渠道失败:' + response.data.message);
						}
					})
					.catch(error => {
						this.$message.error((error && error.userMessage) || '获取渠道失败');
					});
			},
			showDetail(row) {
				const loading = this.openLoading();
				post('419', {
						objId: row.id
					})
					.then(response => {
						if (response.data.result == 0) {
							this.detail = response.data.data;
							this.detailVisible = true;
							loading.close();
						} else {
							this.$message.error('获取详情失败:' + response.data.message);
							loading.close();
						}
					})
					.catch(error => {
						this.$message.error((error && error.userMessage) || '获取详情失败');
						loading.close();
					});
			},
			handleCurrentChange() {
				this.GetData();
			},
			handleSizeChange(size) {
				this.queryParams.pageSize = size;
				this.GetData();
			},
			openLoading() {
				return this.$loading({
					lock: true,
					text: 'Loading',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.4)'
				});
			},
			getBusinessTypeText(t) {
				const map = {
					6: '驾驶人体检表',
					7: '健康证申请表',
					8: '体检从业名单'
				};
				return map[t] || ('类型' + t);
			},
			getPrintStatusText(s) {
				if (s === 1) return '已打印';
				if (s === 2) return '失败';
				return '未打印';
			},
			getPrintStatusTag(s) {
				if (s === 1) return 'success';
				if (s === 2) return 'danger';
				return 'info';
			}
		},
		mounted() {
			this.GetChannelData();
			this.GetData();
		},
		computed: {
			SelectChannelId: {
				get() {
					return this.queryParams.channelId || '';
				},
				set(val) {
					this.queryParams.channelId = val || 0;
				}
			}
		}
	}
</script>

<style>
	.flex-box {
		padding: 10px;
	}

	.search-box {
		display: flex;
		flex-wrap: wrap;
		align-items: center;
		gap: 8px 0;
	}

	.searchItemName {
		display: inline-block;
		width: 80px;
		text-align: right;
		margin-right: 6px;
		font-size: 14px;
		color: #606266;
	}

	.input-box {
		width: 160px;
	}
</style>
